export const MEGABYTE = 1024 * 1024
